<template lang='pug' src='./custom-patient-insurance.pug'></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      active: false,
      line2: false,
      line3: false,
      line4: false
    }
  },
  methods: {
    stringToArrayTitle (i) {
      let textArr = i.split('')
      return textArr
    },
    currentMath (i) {
      let length = this.stringToArrayTitle(i).length - 1
      let sum = length * 0.01 + 0.5
      return sum
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-patient-insurance.vue?76db4d4c